<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main" v-loading="isLoading">
          <ucMenu num="1"></ucMenu>
          <div class="right_con">
            <div class=" upm">
              <div class=" upm_title">采购管理</div>
              <div class=" upm_tools">
                <div class="prefix">
                  <el-button class="error" :disabled="currentSelectedId.length < 1" @click="handlerDelete({id:null})">删除</el-button>
                  <el-button class="primary" @click="handlerCreateDialog({})">新增</el-button>
                </div>
                <div class="suffix">
                  <el-select v-model="query.auth_status" size="small" placeholder="授权状态" clearable style="width: 120px; margin-right: 10px;" @change="getList(true)">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="正常" value="normal"></el-option>
                    <el-option label="失效" value="invalid"></el-option>
                  </el-select>
                  <el-input placeholder="请输入采购账号" v-model="query.keyword" size="small">
                    <template slot="prepend">采购账号</template>
                  </el-input>
                  <el-button class="light" @click="getList(true)">查询</el-button>
                  <el-button @click="query.keyword = ''; query.auth_status = ''; getList(true)">重置</el-button>
                </div>
              </div>
              <div class=" upm_table">
                <div class=" upm_table_header">
                  <div class="col col_selected_all">
                    <el-checkbox v-model="isSelectedAll" @change="handlerSelectAll"></el-checkbox>
                    <span style="white-space: nowrap;">全选</span>
                  </div>
                  <div class="col col_account" style="width: 100px;">所属平台</div>
                  <div class="col col_account">采购账号</div>
                  <div class="col col_account">利润差</div>
                  <div class="col col_account">名称</div>
                  <div class="col col_account">分组</div>
                  <div class="col col_account">授权</div>
                  <div class="col col_operation" style="text-align: right;">操作</div>
                </div>
                <div class="upm_table_line" v-for="(item, index) in list" :key="item.id">
                  <div class="col_selected_all"><el-checkbox v-model="list[index].checked" @change="handlerItemSelect"></el-checkbox></div>
                  <div class="col_account" style="width: 100px;">
                    <div class="col_account_content" style="width: 60px;">
                      <span>{{item.type == 1 ? '多多' : '巴巴' }}</span>
                    </div>
                  </div>
                  <div class="col_account">
                    <div class="col_account_content">
                      <span>{{item.phone}}</span>
                      <p><el-tag size="mini" v-if="item.is_default">默认</el-tag></p>
                    </div>
                  </div>
                  <div class="col_account">
                    <div class="col_account_content">
                      <span>{{item.profit_margin}}</span>
                    </div>
                  </div>
                  <div class="col_account">
                    <div class="col_account_content">
                      <span>{{item.name??'--'}}</span>
                    </div>
                  </div>
                  <div class="col_account">
                    <div class="col_account_content">
                      <div style="white-space: normal;">
                        <el-tag
                            size="mini"
                            type="info"
                            v-for="groupId in item.groupids_bak"
                            :key="groupId"
                            style="margin-top: 2px"
                        >
                          {{ groupList.find(g => g.id == groupId)?.name || '未知分组' }}
                        </el-tag>
                      </div>
                    </div>
                  </div>
                  <div class="col_account">
                    <div class="auth_box" v-if="item.type == 2">
                      <p v-if="item.auth_status">
                        <el-tag size="mini" :type="item.auth_status.val == 1 ? 'success' : 'danger'">{{ item.auth_status.text }}</el-tag>
                      </p>
                      <template v-if="item.alibaba_account_id > 0">
                        <p>账号:{{item.alibaba_account.name}}</p>
                        <p>授权有效期:</p>
                        <p>{{item.alibaba_account.refresh_token_due_text}}</p>
                        <p @click="handlerOpenPay(item)" v-if="item.is_without_code_pay != 1" style="color: #f0413e;cursor: pointer;">开通免密支付</p>
                      </template>
                    </div>
                  </div>
                  <div class="col_operation">
                    <div class="col_operation_content">
                      <el-button class="primary mb-2" v-if="item.type == 2" @click="handlerToAuth(item)">巴巴授权</el-button>
                      <el-button class="primary mb-2" v-if="item.is_default == 0" @click="handlerSetDefault(item)">设为默认</el-button>
                      <el-button class="primary mb-2" @click="handlerSyncPddOrder(item)">更新采购订单</el-button>
                      <div>
                        <el-button class="primary mb-2 mr-6" @click="handlerCreateDialog(item)">修改</el-button>
                        <el-popconfirm title="删除后无法恢复，是否继续？" @confirm="handlerDelete(item)">
                          <template #reference>
                            <el-button class="error">删除</el-button>
                          </template>
                        </el-popconfirm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class=" upm_pagination">
                <Pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.size" @pagination="getList" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]"/>
              </div>
						</div>
					</div>
				</div>
			</div>
		</div>
    <el-dialog v-if="default_form.visible" :title="default_form.title" :visible.sync="default_form.visible" width="700px" >
      <formComponent
          :detail="default_form.payload"
          :groupList = groupList
          :allocatedGroupIds = allocated_group_ids
          @confirm="handlerDefaultFormConfirm"
          @cancel="handlerDefaultFormCancel"
      ></formComponent>
    </el-dialog>

		<myFoot></myFoot>
	</div>
</template>

<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import myHead from "@/components/myHead/myhead.vue";
import Pagination from '@/components/pagination/pagination';
import formComponent from "./form.vue"
import {mapActions} from "vuex";

export default {
  data(){
    return{
      isLoading: false,
      query:{
        keyword: '',
        auth_status: '',
      },
      isSelectedAll:false,
      pagination:{
        total: 0,
        size: 5,
        current: 1,
      },
      default_form:{
        visible: false,
        title: '',
        payload:{},
      },
      list: [],
      groupList:[],
      allocated_group_ids:[],
    }
  },
  components:{
    ucMenu,
    myFoot,
    myHead,
    Pagination,
    formComponent
  },
  computed:{
    currentSelectedId(){
      return this.list.filter(item=>item.checked).map(item=>item.id)
    },
  },
  mounted() {
    this.getList(true)
    this.getGroupList()
  },
  methods:{
    ...mapActions({
      opPddAccountList:"ucenter_order/opPddAccountList",
      opPddAccountAdd:"ucenter_order/opPddAccountAdd",
      opPddAccountDel:"ucenter_order/opPddAccountDel",
      opPddAccountUpdate:"ucenter_order/opPddAccountUpdate",
      opPddAccountDefault:"ucenter_order/opPddAccountDefault",
      opPddAccountSyncOrder:"ucenter_order/opPddAccountSyncOrder",
      getShopBoardGroupList: "shop_board/getShopBoardGroupList",
    }),
    handlerSelectAll(){
      const _status = this.isSelectedAll;
      this.list.map((item, index)=>{
        this.list[index].checked = _status;
      })
    },
    handlerItemSelect(){
      this.handlerValidateSelectAll();
    },
    handlerValidateSelectAll(){
      let all = this.list.length > 0;
      for(let item of this.list){
        if(!item.checked){
          all = false;
          break;
        }
      }
      this.isSelectedAll = all;
    },
    refresh(){
      this.getList(false)
    },
    getList(reset = false){
      if(reset){
        this.pagination.current = 1;
      }
      this.opPddAccountList({
        data:{
          page: this.pagination.current,
          limit: this.pagination.size,
          keyword: this.query.keyword,
          group_ids: [],
          auth_status: this.query.auth_status,
        },
        success:(res)=>{
          this.list = res.data.data.map(item=>{
            item.groupids_bak = []
            if (typeof item.group_ids === 'string') {
              item.groupids_bak = item.group_ids ? item.group_ids.split(',').map(Number).filter(Boolean) : []
              item.group_ids = item.groupids_bak.filter(id =>this.groupList.some(g => g.id === id))
            }
            return Object.assign(item, {checked: false})
          });
          this.pagination.current = res.data.current_page;
          this.pagination.total = res.data.total;
          this.allocated_group_ids = res?.data?.group_ids || [];
        }
      })
    },
    handlerChange(page){
      this.pagination.current = page
      this.getList();
    },
    handlerDelete({id}){
      let _id = id;
      if(_id === null){
        if(this.currentSelectedId.length < 1){
          this.$message({message: '请选择要删除的数据',type: 'warning',});
          return false;
        }
        _id = this.currentSelectedId.join(',')
        this.$confirm('删除后无法恢复，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.postDelete(_id)
        }).catch(() => {})
        return
      }
      this.postDelete(_id)
    },
    postDelete(_id) {
      this.isLoading = true;
      this.opPddAccountDel({
        data:{
          id: _id
        },
        success: (res) => {
          this.isLoading = false;
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
          this.getList();
        }
      })
    },
    handlerToAuth(item) {
      window.open(item.auth_url)
    },
    /** 默认表单 */
    handlerCreateDialog(data = {}){
      this.default_form.title = data.id ? '修改采购' : '新增采购';
      this.default_form.payload = Object.assign({
        alibaba_auto_purchase: 0,
        alibaba_auto_purchase_delay: 0,
        auto_deal_dd_after_sales: 1,
        shipping_risk_fee_enable: 0,
        shipping_risk_fee_amount: 0,
        shipping_risk_ratio_enable: 0,
        shipping_risk_ratio_base: 'dd_order',
        shipping_risk_ratio_percent: 0,
      }, data);
      // checkbox true-label 需要数字，兼容接口字符串/布尔
      this.default_form.payload.shipping_risk_fee_enable = Number(this.default_form.payload.shipping_risk_fee_enable) ? 1 : 0;
      this.default_form.payload.shipping_risk_ratio_enable = Number(this.default_form.payload.shipping_risk_ratio_enable) ? 1 : 0;
      if (!this.default_form.payload.shipping_risk_ratio_base) {
        this.default_form.payload.shipping_risk_ratio_base = 'dd_order';
      }
      this.changeDialogVisible('default_form');
    },
    handlerDefaultFormCancel(){
      this.changeDialogVisible('default_form', false);
    },
    handlerDefaultFormConfirm(param){
      if(!param.type){
        this.$message({message: '请选择所属平台',type: 'warning',});
        return;
      }
      if(param.type==2&&param.alibaba_auto_purchase==null){
        this.$message({message: '请选择是否自动采购',type: 'warning',});
        return;
      }
      if(!param.phone){
        this.$message({message: '手机号不能为空',type: 'warning',});
        return;
      }
      if(param.auto_deal_dd_after_sales == null){
        this.$message({message: '请选择是否自动售后',type: 'warning',});
        return;
      }
      if(param.type == 2){
        const feeEnable = Number(param.shipping_risk_fee_enable) === 1;
        const ratioEnable = Number(param.shipping_risk_ratio_enable) === 1;
        if(feeEnable){
          const feeAmount = Number(param.shipping_risk_fee_amount);
          if(param.shipping_risk_fee_amount === '' || param.shipping_risk_fee_amount === null || Number.isNaN(feeAmount) || feeAmount < 0){
            this.$message({message: '运费风控：请填写有效的代发费阈值N（≥0）',type: 'warning',});
            return;
          }
        }
        if(ratioEnable){
          const ratioPercent = Number(param.shipping_risk_ratio_percent);
          if(!param.shipping_risk_ratio_base){
            this.$message({message: '运费风控：请选择占比分母',type: 'warning',});
            return;
          }
          if(param.shipping_risk_ratio_percent === '' || param.shipping_risk_ratio_percent === null || Number.isNaN(ratioPercent) || ratioPercent <= 0){
            this.$message({message: '运费风控：请填写有效的占比阈值n（>0）',type: 'warning',});
            return;
          }
        }
      }
      this.isLoading = true;

      const func = param?.id > 0 ? this.opPddAccountUpdate : this.opPddAccountAdd;

      func({
        data: param,
        success: (res) => {
          this.isLoading = false;
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
          this.getList();
          this.changeDialogVisible('default_form', false);
        }
      })
    },
    handlerSyncPddOrder({id}){
      this.isLoading = true;
      this.opPddAccountSyncOrder({
        data:{
          id: id
        },
        success: (res) => {
          this.isLoading = false;
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
          this.getList();
        }
      })
    },
    handlerSetDefault({id}){
      this.isLoading = true;
      this.opPddAccountDefault({
        data:{
          id: id
        },
        success: (res) => {
          this.isLoading = false;
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
          this.getList();
        }
      })
    },
    /** Dialog操作 */
    changeDialogVisible(mode, visible = true){
      this[mode].visible = visible;
      if(!visible){
        this.resetDialogPayload(mode)
      }
    },
    resetDialogPayload(mode, _val = {}){
      this.$set(this[mode], 'payload', _val)
    },
    handlerOpenPay(){
      let html = `<div>
					<p style="font-weight: bold;font-size: 14px;">开启后，免密订单笔数无限制，采购更快捷</p>
					<p style="font-size: 12px;">1、请使用当前登录的1688账号绑定支付宝；</p>
					<p style="font-size: 12px;">2、且务必宝石支付宝余额充足，余额不足将不能支付；</p>
					<p style="font-size: 12px;">3、单笔支付限额500元/笔;支付笔数不限。</p>
				</div>`
      this.$alert(html, '开通支付宝免密支付', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '去开通',
        cancelButtonText: '暂不开通',
        closeOnClickModal: true,
        closeOnPressEscape: true,
        showClose: false,
        showCancelButton: true,
        customClass: 'zdy-message-box'
      }).then(() => {
        window.open('https://tradeconfig.1688.com/foundation/withhold_manage.htm')
      })
    },
    getGroupList(){//获取系统权限列表
      //加载分组信息
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || [];
          } else {
            this.$message.error(res.message || '获取分组失败');
          }
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.mb-2{
  margin-bottom: 2px;
}
.mr-6{
  margin-right: 6px;
}

.center{display: flex;flex: 1;}

.upm{
  font-family: MicrosoftYaHei;
  padding: 36px 40px;
  &_title{
    font-size: 16px;
    font-weight: bold;
    color: #333333;
  }
  &_tools{
    margin: 24px 0 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .prefix{
      display: flex;
      .el-button{
        width: 72px;
        height: 32px;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        &.error{
          border-color: #f0413e;
          background-color: #f0413e;
        }
        &.primary{
          border-color: #1966ff;
          background-color: #1966ff;
        }
      }
    }
    .suffix{
      display: flex;
      .el-input{
        width: 240px;
        height: 32px;
        margin-right: 10px;
        :deep(.el-input-group .el-input-group__prepend){
          padding: 0 10px;
          font-size: 12px;
          background: transparent;
        }
        :deep(&__inner){
          border-left: unset;
          padding: 0 16px;
          font-size: 12px;
          height: 32px;
          border-color: #dcdfe6;
        }
      }
      .el-button{
        width: 60px;
        height: 32px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        font-size: 12px;
        &.light{
          color: #f0413e;
          border: solid 1px #f0413e;
        }
      }
    }
  }
  &_table{
    width: 100%;
    .col{
      font-size: 12px;
      color: #666666;
      display: flex;
      align-items: center;
      &_selected_all{
        width: 80px;
        margin-left: 20px;
        .el-checkbox{
          margin-right: 10px;
          :deep(&__label){
            font-size: 12px;
            color: #666666;
          }
        }
      }
      &_name{
        margin-left: 20px;width: 190px;
        &_content{
          font-size: 13px;
          line-height: 24px;
          color: #333333;
        }
      }
      &_account{
        margin-left: 20px;width: 220px;
        &_content{
          display: flex;
          flex-direction: column;
          font-size: 13px;
          line-height: 24px;
          color: #333333;
          .el-tag{
            margin-left: 6px;
            background-color: #e4f8e7;
            border-radius: 4px;
            font-size: 12px;
            line-height: 24px;
            color: #0ea11f;
            border-color: transparent;
            padding: 6px;
            align-items: center;
            display: flex;
            width: fit-content;
          }
        }
      }
      &_operation{
        margin-left: 20px;width: 280px;
        &_content{
          display: flex;
          column-gap: 10px;
          flex-wrap: wrap;
          justify-content: flex-end;
          align-items: center;
          flex-direction:column;
          :deep(.el-button){
            font-size: 13px;
            line-height: 24px;
            border: unset;
            height: 14px;
            padding: 0;
            background: transparent;
            margin-left: 0;
            &.primary{
              color: #1966ff;
            }
            &.error{
              color: #f0413e;
            }
          }
        }
      }
    }
    &_header{
      padding: 15px 0 20px 0;
      display: flex;
      width: 100%;
      background-color: #f9f9f9;
    }
    &_line{
      display: flex;
      align-items: center;
      width: 100%;
      padding: 22px 0 28px 0;
      border-bottom: solid 1px #eeeeee;
    }
  }
  &_pagination{
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.auth_box{
  font-size: 12px;
}
</style>
